import integrationsClient, { type ApiDefinition } from '@/tsClient/servers/integrationsService';
import buildPath from '@/tsClient/utilities/buildPath';

type THIS_API = ApiDefinition['/{provider}/creators/{creatorId}/mfa-code']['GET'];
type Input = THIS_API['params'] & THIS_API['query'];
type Output = THIS_API['response'];

const getMFAForIntegrationAccount = async ({ creatorId, username, provider }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>('/{provider}/creators/{creatorId}/mfa-code', { creatorId, provider });
  const response = await integrationsClient.get(path, { params: { username } });
  return response.data;
};

export default getMFAForIntegrationAccount;
